import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import React, { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Box } from '@applyboard/ui-components';
import LetterGradeForm from "./LetterGradeForm";
import NumericalGradeForm from "./NumericalGradeForm";
import OtherGradeForm from "./OtherGradeForm";
import SchemeForm from "./SchemeForm";
import { GradingSchemeType } from "../Constants";
import { scrollIfNeeded } from "../../Utilities/Helper";
function AnswerForms(_ref) {
  var formValidated = _ref.formValidated,
    gradingSchemes = _ref.gradingSchemes,
    onChange = _ref.onChange,
    value = _ref.value;
  var grade = value.grade,
    gradeMax = value.gradeMax,
    gradingSchemeId = value.gradingSchemeId;
  var gradingScheme = React.useMemo(function () {
    return gradingSchemes.find(function (scheme) {
      return String(scheme.id) === String(gradingSchemeId);
    });
  }, [gradingSchemes, gradingSchemeId]);
  function onSchemeSubmit(gradingSchemeIdValue) {
    onChange({
      gradingSchemeId: Number(gradingSchemeIdValue),
      grade: '',
      gradeMax: ''
    });
  }
  function onGradeSubmit(submittedGrade) {
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    onChange({
      gradingSchemeId: gradingSchemeId,
      grade: submittedGrade,
      gradeMax: max
    });
  }
  var onFormMount = useCallback(function (node) {
    return scrollIfNeeded(node);
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    pb: "16px",
    ref: onFormMount
  }, /*#__PURE__*/React.createElement(SchemeForm, {
    id: "scheme-form",
    gradingSchemes: gradingSchemes,
    gradingSchemeId: gradingSchemeId,
    onSubmit: onSchemeSubmit,
    formValidated: formValidated
  })), gradingScheme && (gradingScheme.type === GradingSchemeType.letter && /*#__PURE__*/React.createElement(Box, {
    ref: onFormMount
  }, /*#__PURE__*/React.createElement(LetterGradeForm, {
    formValidated: formValidated,
    grade: grade,
    id: "letter-grade-form",
    key: gradingSchemeId // Remount form if scheme changes
    ,
    letterGrades: gradingScheme.letter_grades,
    onSubmit: onGradeSubmit
  })) || gradingScheme.type === GradingSchemeType.numerical && /*#__PURE__*/React.createElement(Box, {
    ref: onFormMount
  }, /*#__PURE__*/React.createElement(NumericalGradeForm, {
    formValidated: formValidated,
    grade: grade,
    gradingScheme: gradingScheme,
    id: "numerical-grade-form",
    key: gradingSchemeId // Remount form if scheme changes
    ,
    onSubmit: onGradeSubmit
  })) || gradingScheme.type === GradingSchemeType.other && /*#__PURE__*/React.createElement(Box, {
    pt: "16px",
    ref: onFormMount
  }, /*#__PURE__*/React.createElement(OtherGradeForm, {
    formValidated: formValidated,
    grade: grade,
    gradeMax: gradeMax,
    id: "other-grade-form",
    onSubmit: onGradeSubmit
  }))));
}
export default AnswerForms;